import { useContext } from 'react';

import { ImpressionContext } from '@/common/impressions/ImpressionContext';

export const useImpressionContext = () => {
  const impressionsContext = useContext(ImpressionContext);

  if (typeof Worker !== 'undefined' && !impressionsContext) {
    console.error('ImpressionsContext has to be used within <ImpressionsContextProvider>');
  }

  return impressionsContext;
};
